<template>
  <div class="record-wrap aside-block">
    <div class="record-img">
      <img src="../../../assets/not-record.png"
           alt=""
           v-if="record_status===0">
      <div id="recwave"
           class="wave-container"
           v-else-if="record_status===1"></div>
      <img src="../../../assets/icon-mp3.svg"
           alt=""
           v-else>
    </div>
    <div class="record-status">
      <el-button type="primary"
                 size="small"
                 v-if="record_status===0"
                 @click="startRecord">开始录音</el-button>
      <el-button type="primary"
                 size="small"
                 v-else-if="record_status===1"
                 @click="finishRecord">结束</el-button>
      <div class="flex-x-center"
           v-else>
        <el-button size="small"
                   @click="delRecord">删除</el-button>
        <el-button type="primary"
                   size="small"
                   @click="sendRecord">发送</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../package/recorder.mp3.min.js'
import '../../../package/waveview'
import util from '@/base/js/util'
import { _uploadAudio } from '@/api/upload'
export default {
  data () {
    return {
      rec: null,
      wave: null,
      record_status: 0,
      audioBlob: null,
    }
  },
  mounted () {
    this.rec = Recorder({
      onProcess: (buffers, level, time, sampleRate) => {
        $(".recpowerx").css("width", level + "%");
        $(".recpowert").html(time + "/" + level);

        this.wave.input(buffers[buffers.length - 1], level, sampleRate);
      }
    })
  },
  methods: {
    //开始录音
    startRecord () {
      //获取录音权限
      this.rec.open(() => {
        //获取成功
        this.record_status = 1
        this.$nextTick(() => {
          this.rec.start()
          this.wave = Recorder.WaveView({ elem: ".wave-container" });
        })
      }, (e, isUserNotAllow) => {
        //获取失败
        this.$message.error((isUserNotAllow ? "权限未被允许，" : "") + "打开失败：" + e)
      })
    },
    //结束录音
    finishRecord () {
      this.rec.stop((blob, time) => {
        this.rec.close();//释放录音资源
        //已经拿到blob文件对象想干嘛就干嘛：立即播放、上传
        this.audioBlob = blob
        this.record_status = 2
      }, (e) => {
        this.$message.error('录制失败，' + e)
      })
    },
    //删除语音
    delRecord () {
      this.$confirm('你确定要删除这条录音吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.audioBlob = null
        this.record_status = 0
      }).catch(() => { })
    },
    //发送语音————先上传至服务器，返回地址后再发送socket
    sendRecord () {
      let data = new FormData()
      data.append('audio', this.audioBlob, util.randomId() + '.mp3')
      _uploadAudio({
        data
      }).then(res => {
        this.record_status = 0
        if (res.resultCode == 0) {
          console.log(res)
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.record-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  .record-img {
    height: 70px;
    img {
      height: 100%;
    }
    .wave-container {
      width: 150px;
      height: 70px;
    }
  }
  .record-status {
    margin-top: 15px;
  }
}
</style>
